module.exports = __webpack_public_path__ + "static/media/fig_8b.ee827f4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_8b.jpg
// module id = 682
// module chunks = 0